<script lang="ts" module>
  import { tv } from 'tailwind-variants';

  import BaseBtn from '@/ui/base/BaseBtn.svelte';
  import Icon from '@/ui/base/icon/Icon.svelte';

  export type DropDownLoginItem = {
    label: string;
    value: string;
    disabled?: boolean;
  };

  interface DropDownSelectProps {
    item: DropDownLoginItem;
    selected?: boolean;
  }
</script>

<script lang="ts">
  let { selected = false, ...props }: DropDownSelectProps = $props();

  // TODO add tailwind styles
  const styles = tv({
    base: 'flex w-full bg-white px-4 py-2 text-left font-sans text-md hocus:bg-dropdownlogin-H',
    variants: {
      selected: {
        true: 'font-semibold',
        false: 'font-normal',
      },
      disabled: {
        true: 'text-c-disabled',
        false: 'text-c-base',
      },
    },
  });
</script>

<BaseBtn
  class={styles({
    selected: selected && !props.item.disabled,
    disabled: props.item.disabled ?? false,
  })}
>
  <div class="flex-1">
    {props.item.label}
  </div>
  {#if selected && !props.item.disabled}
    <Icon icon="CheckCircleOutline" class="size-4 text-c-success"></Icon>
  {/if}
</BaseBtn>
